import { InitiativeSonarObject } from '@types';
import { createGetEndpoint, getQueryString } from '@sonar-software/sonar-http';
import { OffsetPaginatedResource, OffsetPaginationParams, SonarSortDirection } from '@sonar-software/sonar-ts-types';

export type GetInitiativeSonarObjectsRequest = OffsetPaginationParams & {
	initiativeId: number;
	objectNameSearchText?: string;
	objectTypes?: Array<string>;
	sortBy?: string;
	sortDirection?: SonarSortDirection;
};

export type GetInitiativeSonarObjectsResponse = OffsetPaginatedResource<InitiativeSonarObject>;

export const getInitiativeSonarObjects = createGetEndpoint<
	GetInitiativeSonarObjectsRequest,
	GetInitiativeSonarObjectsResponse
>(({ initiativeId, ...rest }) => `/api/v2/initiatives/${initiativeId}/sonarobjects?${getQueryString(rest)}`);
